module.exports = __webpack_public_path__ + "img/Articles_cards.ee8134ad.png";